import { cltService } from "@/app/services/cltService";
import { AuthorizationResponse } from "@/app/services/cltService/requestAuthorization";
import { validateCpf } from "@/app/utils/cpfFormater";
import masks from "@/app/utils/masks";
import { useToast } from "@/view/components/ui/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
import { z } from "zod";

const getAvailableRegisterSchema = z.object({
  cpf: z.string().refine((v) => validateCpf(v || ""), {
    message: "CPF inválido",
  }),
});

type getAvailableRegisterFormData = z.infer<typeof getAvailableRegisterSchema>;

export default function useNewSimulationModal() {
  const navigate = useNavigate();
  const { toast } = useToast();

  const [list, setList] = useState<AuthorizationResponse[] | undefined>(
    undefined,
  );
  const [selectedCard, setSelectedCard] = useState<
    AuthorizationResponse | undefined
  >(undefined);

  const form = useForm<getAvailableRegisterFormData>({
    resolver: zodResolver(getAvailableRegisterSchema),
    mode: "onChange",
  });

  const { mutateAsync: requestAuth, isPending } = useMutation({
    mutationFn: (cpf: string) => cltService.requestAuthorization(cpf),
    onSuccess: (data) => {
      data?.filter((item) => item.Elegivel);
      setList(data?.filter((item) => item.Elegivel) || []);
    },
    onError: (error: unknown) => {
      const err = error as {
        response?: { data?: { message?: string } };
        message?: string;
      };
      toast({
        title: "Erro ao buscar matrículas",
        description:
          err?.response?.data?.message ||
          err?.message ||
          "Erro inesperado. Tente novamente mais tarde.",
        variant: "destructive",
      });
    },
  });

  const handleSubmit = form.handleSubmit(async (data) => {
    const cleanCpf = data.cpf.replace(/\D/g, "");

    if (!validateCpf(cleanCpf)) {
      setList([]);
      return;
    }

    try {
      setSelectedCard(undefined);
      await requestAuth(data.cpf);
    } catch (error) {
      console.log(error);
    }
  });

  const handleNext = () => {
    const cpf = form.getValues("cpf");
    if (!cpf) return;
    navigate(`/transacoes/${masks.number(cpf)}/clt`);
  };

  const cpf = form.watch("cpf");

  useEffect(() => {
    if (!cpf) return;

    const cleanCpf = cpf.replace(/\D/g, "");

    if (cleanCpf.length !== 11) {
      setList(undefined);
      return;
    }

    if (!validateCpf(cleanCpf)) {
      form.setError("cpf", {
        type: "manual",
        message: "CPF inválido",
      });
      setList(undefined);
      return;
    }

    form.clearErrors("cpf");
    handleSubmit();
  }, [cpf]);

  return {
    form,
    isPending,
    handleSubmit,
    list,
    selectedCard,
    setSelectedCard,
    handleNext,
  };
}
